import { IRootState } from '../../../store'
import { ICmsInformationState } from '../store/cmsInformation.types'

export const getCmsInformationSelector = (state: IRootState): ICmsInformationState => state.cmsInformation
